const renderMode = {
  normal: 'normal',
  logo: 'logo',
  brand: 'brand'
}

export default renderMode
